import { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import styles from '../../Encounters.module.scss';
import { EncountersListState as EncountersListStateType } from '../../hooks';

type EncountersListStateProps = {
  state: EncountersListStateType;
};

export const EncountersListState: FC<EncountersListStateProps> = (props) => {
  const { state } = props;

  if (state.kind === 'ready') {
    return null;
  }

  if (state.kind === 'no-organization') {
    return (
      <div className={styles.state}>
        <FormattedMessage
          id="encounters.noOrganization"
          defaultMessage="No organization selected."
        />
      </div>
    );
  }

  if (state.kind === 'loading') {
    return (
      <div className={styles.state}>
        <FormattedMessage id="global.loading" defaultMessage="Loading…" />
      </div>
    );
  }

  if (state.kind === 'error') {
    return (
      <div className={styles.state}>
        <FormattedMessage
          id="encounters.error"
          defaultMessage="Error: {message}"
          values={{ message: state.message }}
        />
      </div>
    );
  }

  return (
    <div className={styles.state}>
      <FormattedMessage id="encounters.empty" defaultMessage="No encounters." />
    </div>
  );
};
